module.exports = __webpack_public_path__ + "img/se.b6a40755.svg";